<template>
  <Modal :is-open="isOpen" :closeable="false">
    <span
      v-html="
        translation.itemList.useConfirmMessage(
          item.name,
          pokemon.name
        )
      "
    ></span>

    <template #footer>
      <button type="button" class="btn btn-primary" @click="$emit('useItem')" :disabled="pokemon.locked && item.price > 2000">
        {{ translation.general.okay }}
      </button>

      <button
        type="button"
        class="btn btn-secondary"
        @click="$emit('update:is-open', false)"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../Modal/Modal.vue";
import { translation } from "@/utils/translations";

export default {
  components: { Modal },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    pokemon: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["update:is-open", "useItem"],
  setup() {
    return {
      translation,
    };
  },
};
</script>
